/**
 * Orden de los documentos dentro de una fase (OT-0006): el de las subfases
 * del ciclo (`subphase_order`), no el texto de `subphase_code`. Los códigos
 * son opacos: `acta`, `1.1` o `phase-2.10` no dicen su posición.
 */

import type { ProjectSubphase } from '../../api/projects'

/** Comparador por la posición de la subfase en la fase. Las subfases que la
 * fase no declara (o documentos sin subfase) van al final, en el orden en
 * que llegan. */
export function bySubphaseOrder(
  subphases: ProjectSubphase[],
): (a: { subphase_code: string | null }, b: { subphase_code: string | null }) => number {
  const order = new Map(subphases.map((sp) => [sp.subphase_code, sp.subphase_order]))
  const position = (code: string | null) =>
    (code !== null ? order.get(code) : undefined) ?? Number.POSITIVE_INFINITY
  return (a, b) => {
    const pa = position(a.subphase_code)
    const pb = position(b.subphase_code)
    return pa === pb ? 0 : pa < pb ? -1 : 1
  }
}
